import React from "react"
import PropTypes from "prop-types"
class AccountLookup extends React.Component {
  constructor(props) {
    super(props)
  }

  renderAccountRows(data) {
    return data && data.map((a) =>
      (
        <tr key={a.id} onClick={() => this.props.handleAccountTrClick(a)} className={(this.props.selectedAccount.SFDC_account_id === a.SFDC_account_id ? 'table-success' : '')} style={{cursor: "pointer"}}>
          <td>{a.SFDC_account_id}</td>
          <td>{a.name}</td>
          <td>{a.account_site_location}</td>
          <td>{a.region}</td>
        </tr>
      )); // no need to bind with anon function
  }

  render () {
    return (
      <React.Fragment>
        <table className="table table-hover table-bordered table-sm">
          <thead>
              <tr>
                <th>Account ID</th>
                <th>Account</th>
                <th>Account Site</th>
                <th>Region</th>
              </tr>
          </thead>
          <tbody>
            {this.renderAccountRows(this.props.accounts)}
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

AccountLookup.propTypes = {
  accounts: PropTypes.array
};
export default AccountLookup
